import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import flyer from "../../images/back-to-school.jpg";

import Header, { NavLinks, NavLink as NavLinkBase } from "../headers/light.js";

const NavLink = tw(NavLinkBase)`
  sm:text-sm sm:mx-6
`;

const HeroImage = styled.div`
  background-image: url("${flyer}");
  ${tw`flex flex-col min-h-96 self-center bg-no-repeat bg-contain items-center justify-center bg-center`}
`;

export default ({
  navLinks = [
    <NavLinks key={1}>
      <NavLink href="/">Home</NavLink>
      <NavLink href="/about">About Us</NavLink>
      <NavLink href="#">Become a Member</NavLink>
      <NavLink href="#">Volunteer</NavLink>
      <NavLink href="/wish">Teacher Wish Lists</NavLink>
      <NavLink href="#">Fundraising</NavLink>
      <NavLink href="#">Uniform Shop</NavLink>
      <NavLink href="#">Contact Us</NavLink>
    </NavLinks>
  ]
}) => {
  return (
    <>
      <Header links={navLinks} />
      <HeroImage></HeroImage>
    </>
  );
};
